import { CountUp } from 'countup.js';

export default class Packages {
  // html selector for the component
  static selectorString() {
    return '.js-package-form';
  }

  // rootNode = html element with js-class
  // props = data attribute 'props' to pass down customization
  constructor(rootNode) {
    this.defaultPrice = +rootNode.dataset.startPrice || 0;
    //  [...rootNode.querySelectorAll('.checkbox-checkbox:disabled:not(.package-complete)')].reduce(this.sumUp, 0) ||
    this.$refs = {
      rootNode,
      checkboxes: [...rootNode.querySelectorAll('.checkbox-checkbox')],
      completePackageCheckbox: rootNode.querySelector('.package-complete'),
      priceTag: rootNode.querySelector('.package-form-price-value'),
    };

    this.countUp = new CountUp(this.$refs.priceTag, 2000, {
      startVal: 0,
      separator: '.',
      suffix: ',-',
    });

    this.setupCheckboxListener();
    // needed bc the event-handler in package-toggle is added afterwards
    setTimeout(this.updatePrice.bind(this), 2500);
  }

  setupCheckboxListener() {
    // disable all if total package is checked
    this.$refs.completePackageCheckbox.addEventListener('change', e => {
      if (e.target.checked) {
        this.$refs.checkboxes.forEach(checkbox => {
          if (!checkbox.classList.contains('package-complete') && !checkbox.disabled) checkbox.checked = false;
        });
      }
    });

    // update price on checkbox change
    // uncheck complete package if another checkbox is clicked
    this.$refs.checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', e => {
        if (!e.target.classList.contains('package-complete')) this.$refs.completePackageCheckbox.checked = false;

        this.updatePrice();
      });
    });
  }

  sumUp(sum, checkbox) {
    if (checkbox.checked && checkbox.dataset.price) return sum + parseInt(checkbox.dataset.price);

    return sum;
  }

  updatePrice() {
    const price = this.$refs.checkboxes.reduce(this.sumUp, this.defaultPrice);

    this.countUp.update(price);

    this.emitEvent(`price-update-${this.$refs.rootNode.id}`, {
      id: this.$refs.rootNode.id,
      price,
    });
  }

  emitEvent(type, detail = {}, elem = document) {
    // Make sure there's an event type
    if (!type) return;

    // Create a new event
    const event = new CustomEvent(type, {
      bubbles: true,
      cancelable: true,
      detail: detail
    });

    // Dispatch the event
    return elem.dispatchEvent(event);
  }
}
